import React from "react"

export const AudioModal = ({ params }) => (
    <>
      <div className="audio-container">
        <audio
          id="audio"
          className="audio"
          src={params.source.src}
          controls
        ></audio>
      </div>
      <div className="button-wrapper">
        <button className="text-center btn col-4" onClick={params.onCancel}>
          Ok
        </button>
      </div>
    </>
)
